var _path, _path2, _g, _path3, _path4, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _rect9, _rect10, _path5, _path6, _g3, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_2433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 82,
    width: 152,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_2433)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 180,
    height: 76,
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 104,
    width: 180,
    height: 38,
    fill: "black",
    fillOpacity: 0.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 75C25 75.0205 25.0141 74.8164 25 74C25.1834 73.5235 25.402 72.5029 26 71C26.8267 67.944 28.7804 64.4435 32 61C41.6944 50.6002 60.1724 44 90 44C119.828 44 138.306 50.6004 148 61C151.22 64.4435 153.173 67.944 154 71C154.598 72.5029 154.817 73.5236 155 74C154.986 74.8164 155 75.0205 155 75V114C155 113.896 154.972 114.501 155 115C154.739 117.117 154.471 119.015 154 121C152.814 126.991 150.606 132.911 147 138C137.283 154.337 119.255 164 90 164C60.7448 164 42.7164 154.338 33 138C29.3941 132.911 27.1865 126.991 26 121C25.529 119.015 25.261 117.117 25 115C25.0283 114.547 25.0001 113.677 25 114V75Z",
    fill: "#E1E6E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3_2433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 75C25 75.0205 25.0141 74.8164 25 74C25.1834 73.5235 25.402 72.5029 26 71C26.8267 67.944 28.7804 64.4435 32 61C41.6944 50.6002 60.1724 44 90 44C119.828 44 138.306 50.6004 148 61C151.22 64.4435 153.173 67.944 154 71C154.598 72.5029 154.817 73.5236 155 74C154.986 74.8164 155 75.0205 155 75V114C155 113.896 154.972 114.501 155 115C154.739 117.117 154.471 119.015 154 121C152.814 126.991 150.606 132.911 147 138C137.283 154.337 119.255 164 90 164C60.7448 164 42.7164 154.338 33 138C29.3941 132.911 27.1865 126.991 26 121C25.529 119.015 25.261 117.117 25 115C25.0283 114.547 25.0001 113.677 25 114V75Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3_2433)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 42,
    width: 138,
    height: 124,
    fill: "#B0BEC5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 129,
    width: 68,
    height: 22,
    rx: 5,
    fill: "black",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 133,
    width: 60,
    height: 14,
    rx: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 133,
    width: 4,
    height: 14,
    fill: "black",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 133,
    width: 4,
    height: 14,
    fill: "black",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 133,
    width: 4,
    height: 14,
    fill: "black",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 133,
    width: 4,
    height: 14,
    fill: "black",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 87,
    width: 104,
    height: 34,
    rx: 17,
    fill: "black",
    fillOpacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 104,
    r: 13,
    fill: "#F1EEDA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 113,
    cy: 104,
    r: 13,
    fill: "#F1EEDA"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 99,
    width: 10,
    height: 10,
    rx: 2,
    fill: "black",
    fillOpacity: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 99,
    width: 10,
    height: 10,
    rx: 2,
    fill: "black",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92 5H88V36H80C78.8954 36 78 36.8954 78 38V52H102V38C102 36.8954 101.105 36 100 36H92V5Z",
    fill: "#E1E6E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3_2433",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 5,
    width: 24,
    height: 47
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92 5H88V36H80C78.8954 36 78 36.8954 78 38V52H102V38C102 36.8954 101.105 36 100 36H92V5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3_2433)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    width: 100,
    height: 52,
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 36,
    width: 24,
    height: 16,
    fill: "white",
    fillOpacity: 0.2
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 8,
    r: 8,
    fill: "#FFE65C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 5,
    r: 3,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot7);
export default __webpack_public_path__ + "static/media/bot-7.a6c17b7749e14affaca6d8ac5c750043.svg";
export { ForwardRef as ReactComponent };